export const msalConfig = {
  auth: {
    clientId: "53f86be7-d627-4bd8-9d35-6a77ce20b8d7",
    authority: "https://login.microsoftonline.com/9e079ee9-a0ee-429e-8f3b-4e56cf271ebe",
    redirectUri: window.location.hostname === "localhost" 
      ? "http://localhost:3000" 
      : "https://apps.acom.edu.au",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "User.Read.All", "openid", "profile", "GroupMember.Read.All", "Group.Read.All", "Directory.Read.All"],
};